<template>
	<v-container class="fill-height d-flex align-center justify-center">
		<v-card class="cancel-card pa-6" max-width="480" width="100%" elevation="2">

			<div v-if="!submitted">
				<div class="text-center mb-6">
					<v-icon size="56" color="error">mdi-account-cancel-outline</v-icon>
					<h2 class="mt-3 mb-1 font-weight-bold">Cancelar Conta</h2>
					<p class="text--secondary body-2">
						Insira o seu endereço de e-mail para solicitar o cancelamento da conta no Gugla Empresas.
					</p>
				</div>

				<v-form ref="form" v-model="valid" @submit.prevent="submitRequest">
					<v-text-field
						v-model="inputEmail"
						label="Endereço de e-mail"
						type="email"
						outlined
						dense
						:rules="emailRules"
						prepend-inner-icon="mdi-email-outline"
						placeholder="exemplo@email.com"
					/>

					<v-btn
						type="submit"
						block
						depressed
						color="error"
						:loading="loading"
						:disabled="!valid || loading"
						class="mt-2"
					>
						Solicitar Cancelamento
					</v-btn>

					<v-btn
						text
						block
						class="mt-3 text--secondary"
						@click="$router.back()"
					>
						Voltar
					</v-btn>
				</v-form>
			</div>

			<div v-else class="text-center py-6">
				<v-icon size="64" color="success">mdi-email-check-outline</v-icon>
				<h2 class="mt-4 mb-2 font-weight-bold">Verifique o seu e-mail</h2>
				<p class="body-1 mb-1">
					Enviámos um link de confirmação para
				</p>
				<p class="font-weight-medium error--text mb-4">{{ inputEmail }}</p>
				<p class="body-2 text--secondary">
					Clique no link recebido na sua caixa de entrada para concluir o cancelamento da conta.
					Caso não encontre o e-mail, verifique a pasta de spam.
				</p>
			</div>

		</v-card>
	</v-container>
</template>

<script>
export default {
	props: {
		id: {
			required: true,
		},
		email: {
			required: true,
		},
	},

	data() {
		return {
			valid: false,
			loading: false,
			submitted: false,
			inputEmail: this.email || "",
			emailRules: [
				(v) => !!v || "O e-mail é obrigatório.",
				(v) => /.+@.+\..+/.test(v) || "Insira um e-mail válido.",
			],
		};
	},

	methods: {
		submitRequest() {
			if (!this.$refs.form.validate()) return;

			this.loading = true;
			this.$store
				.dispatch("cancelAccount", { id: Number(this.id), email: this.inputEmail })
				.finally(() => {
					this.loading = false;
					this.submitted = true;
				});
		},
	},
};
</script>

<style scoped>
.cancel-card {
	border-radius: 12px;
}
</style>
